import {Component, OnInit} from '@angular/core';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Shipment} from '../services/shipment';
import {ShipmentPackagesService} from '../services/shipment-packages.service';
import {Package} from '../services/package';
import {Moment} from 'moment';
import {combineLatest, forkJoin} from 'rxjs';
import {ShipmentsService} from '../services/shipments.service';
import {ShipmentProductLine} from "../services/shipment-product-line";
import {ShipmentService} from "../services/shipment-service";
import {BranchesService} from "../services/branches.service";
import {AuthService, User, UsersService} from "@hassel-it/angular-common";
import {ActivatedRoute, Router} from "@angular/router";
import {HttpClient} from "@angular/common/http";
import {PermissionsService} from "../permissions.service";

declare let NProgress: any;

@Component({
    selector: 'app-shipment-package-add-modal',
    templateUrl: './shipment-package-add-modal.component.html',
    styleUrls: ['./shipment-package-add-modal.component.scss'],
    providers: [ShipmentPackagesService, UsersService, BranchesService, PermissionsService]
})

export class ShipmentPackageAddModalComponent implements OnInit {

    public modal: NgbModalRef;

    saved: Function;

    saving = false;

    activeShipment: Shipment;
    isReturn: boolean;

    productCode = null;

    public user: User;
    public userKey: string;

    returnProducts = [];

    protected kolliData: {
        price: number,
        sumVolume: number, sumWeight: number,
        sumWeightOverrideActive: boolean,
        sumWeightOverride: { 0: number, 1: number, 2: number }
    };

    allreturnProducts = [
        {
            name: 'GLS - Shop Return Service',
            product_code: 'GLSDK_SR',
            service_codes: 'QR_CODE,SMS_NT,EMAIL_NT',
            showDatepicker: false,
            carrier: 'GLS'
        },
        {
            name: 'GLS - Pick & Return Service',
            product_code: 'GLSDK_PR',
            service_codes: 'SMS_NT,EMAIL_NT',
            showDatepicker: true,
            carrier: 'GLS'
        },
        {
            name: 'Danske Fragtmænd - Enhedsforsendelse Retur',
            product_code: 'DFM_ER',
            service_codes: 'SMS_NT,EMAIL_NT',
            showDatepicker: true,
            carrier: 'DF'
        },
        {
            name: 'Danske Fragtmænd - Stykgods Retur',
            product_code: 'DFM_SGR',
            service_codes: 'SMS_NT,EMAIL_NT',
            showDatepicker: true,
            carrier: 'DF'
        }
    ];

    selectedReturnProduct = null;

    pickupDate: Moment = null;

    dimensions = {
        height: 0,
        length: 0,
        width: 0
    };

    protected getPdf = false;

    protected hasValidationErrors = false;
    protected validationErrorMessage: string;
    protected hasStykgods: ShipmentService;
    protected isInternational: boolean;
    protected loading: boolean;

    protected enableDg = false;
    protected lockPdf: any;
    public branches: any[] = [];
    protected branch: any;


    constructor(public shipmentsService: ShipmentsService,
                public shipmentPackagesService: ShipmentPackagesService,
                public branchesService: BranchesService,
                public authService: AuthService,
                public activatedRoute: ActivatedRoute,
                public usersService: UsersService,
                public http: HttpClient,
                private router: Router,
                public ngbModal: NgbModal,
                public permissionsService: PermissionsService,
    ) {
    }

    protected addCustomProduct() {
        this.customProducts.push({name: null, weight: 0, packaging: null, amount_scanned: 0, error: ''});
    }

    protected removeCustomProduct(customProduct) {
        this.customProducts.splice(this.customProducts.indexOf(customProduct), 1);
    }

    ngOnInit() {

        this.loading = true;
        this.branches = this.branchesService.branchesDetails;

        combineLatest([
            this.activatedRoute.queryParams,
            this.usersService.getCurrentUser(),
            this.permissionsService.buildPermissions()
        ]).subscribe(([params, user]) => {
            this.user = user;
            this.userKey = user.username.split('@')[0];
            const branchField = user.custom_fields.find((item) => {
                return item.key === 'branch'
            });

            if (branchField && branchField.value) {
                this.branch = branchField.value;
            }

            this.returnProducts = this.allreturnProducts.filter((returnProduct) => {
                return returnProduct.carrier === this.activeShipment.carrier;
            });


            this.hasStykgods = this.activeShipment.shipment_services.find((item) => {
                return item.service_code === 'DFM_SG';
            });
            if (this.hasStykgods) {
                this.presetPackaging = 41;
            }

            this.isInternational = this.activeShipment.shipment_services.find((item) => {
                return item.service_code === 'international';
            }) ? true : false;

            this.reset();
            this.handleValidation();
            this.loading = false;
        });
    }


    buildPackages() {
        const arr = [];

        for (const customProduct of this.customProducts) {
            if (customProduct.amount_scanned > 0) {
                arr.push(this.buildPackage(customProduct));
            }
        }

        if (arr.length === 0) {
            arr.push(this.buildPackage());
        }
        return arr
    }


    getPrices() {
        const packages = this.buildPackages();

        const operations = [];
        packages.forEach((shipmentPackage) => {
            operations.push(this.shipmentPackagesService.getPrice(this.activeShipment.id, shipmentPackage, this.branch));
        })

        forkJoin(operations).subscribe({
            next: async (operationResults) => {
                for (const result of operationResults) {
                    if (result.product) {
                        result.product.price = result.price;
                    } else {
                        this.kolliData.price = result.price;
                    }
                }
            },
            error: (error) => {
            },
            complete: () => {
            }
        })
    }

    save() {
        const debug = false; // Set to false for production
        this.saving = true;

        const packages = this.buildPackages();

        const operations = [];
        packages.forEach((shipmentPackage) => {
            if (this.getPdf) {
                operations.push(this.shipmentPackagesService.addShipmentPackage(this.activeShipment.id, shipmentPackage, this.branch, debug, 'pdf', false));
            } else {
                operations.push(this.shipmentPackagesService.addShipmentPackage(this.activeShipment.id, shipmentPackage, this.branch, debug, 'object', false));
            }
        })

        forkJoin(operations).subscribe({
            next: async (operationResults) => {
                try {
                    console.log('Operation results:', operationResults);
                    for (let index = 0; index < operationResults.length; index++) {

                        const operationResult = operationResults[index];

                        console.log('Operation result:', operationResult);
                        if (this.enableDg) {
                            const adrPdf = await this.shipmentPackagesService.printAdrForShipmentPackage(
                                this.activeShipment.id,
                                operationResult.id,
                                this.branch
                            ).toPromise() as Blob | MediaSource;
                            await this.downloadPdf(adrPdf, 'adr-' + index + '.pdf');
                        }

                        if (this.getPdf) {
                            const adrPdf = await this.shipmentPackagesService.printPdfForShipmentPackage(
                                this.activeShipment.id,
                                operationResult.id,
                                this.branch
                            ).toPromise() as Blob | MediaSource;
                            await this.downloadPdf(adrPdf, 'label-' + index + '.pdf');
                            // await this.downloadPdf(operationResult as Blob, 'label-' + index + '.pdf');
                        } else {
                            // Handle object response
                            this.saved(operationResult);
                        }
                    }

                    if (!this.getPdf) {
                        this.modal.close();
                    }
                } catch (error) {
                    this.saving = false;
                    alert('Failed to download package PDF(s). Please try again. ' + (error?.error?.errors ? JSON.stringify(error?.error?.errors) : 'Unknown error'));
                }
            },
            error: (error) => {
                this.saving = false;
                alert('Failed to create package(s). Please try again. ' + (error?.error?.errors ? JSON.stringify(error?.error?.errors) : 'Unknown error'));
            },
            complete: () => {
                this.saving = false;
            }
        });
    }

    private async downloadPdf(pdf: Blob | MediaSource, fileName: string) {
        const url = window.URL.createObjectURL(pdf);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        await new Promise((resolve) => setTimeout(resolve, 300));

        window.URL.revokeObjectURL(url);

        await new Promise((resolve) => setTimeout(resolve, 300));
    }

    close() {
        this.modal.close();
    }

    protected changeProductCode($event: any) {
        this.selectedReturnProduct = $event;
        this.pickupDate = null;
    }

    private buildPackage(customProduct?: any) {

        const shipmentPackage = Object.create(Package.prototype);
        let serviceCodes: string | null = null;

        if (this.isReturn && this.selectedReturnProduct) {
            serviceCodes = this.selectedReturnProduct.service_codes ?? null;  // Extract the service_codes property
        }

        const products = [];
        let description = '';
        for (const shipmentProductLine of this.activeShipment.shipment_product_lines) {
            if (shipmentProductLine.amount_scanned > 0) {
                products.push({
                    amount_scanned: shipmentProductLine.amount_scanned,
                    shipment_product_line_id: shipmentProductLine.id
                });
                description += shipmentProductLine.product_text_1 + "\n";
            }
        }

        shipmentPackage.package_info = {
            products: products,
            product_code: this.selectedReturnProduct ? this.selectedReturnProduct.product_code : null,
            service_codes: serviceCodes,
            description: customProduct ? customProduct.product_text_1 : description,
            sumWeightOverride: {0: customProduct ? customProduct.weight : 0},
            dimensions: this.dimensions,
            pickupDate: this.isReturn && this.pickupDate ? this.pickupDate : null,
            enableDg: this.enableDg
        }

        if (customProduct) {
            shipmentPackage.package_type = customProduct.packaging.packageType;
        } else {
            const packagingService = this.activeShipment.shipment_services.find((item) => {
                return item.service_code === 'packaging'
            });
            shipmentPackage.package_type = packagingService ? packagingService.service_name : null;
        }

        shipmentPackage.product = customProduct;
        return shipmentPackage;
    }



    protected updateShippedAmount( $event: number, product: ShipmentProductLine) {
        product.amount_scanned = $event;
        this.handleValidation();
    }

    protected reset() {
        this.hasValidationErrors = false;
        this.validationErrorMessage = '';
        this.dimensions = {height: 0, length: 0, width: 0};
        this.kolliData = {
            price: null,
            sumWeight: 0,
            sumVolume: 0,
            sumWeightOverrideActive: false,
            sumWeightOverride: {0: 0, 1: 0, 2: 0}
        };
    }


    /// @todo this is copied between control and modal, needs to be refactored
    protected customProducts: any[] = [{product_text_1: null, weight: 0, amount_scanned: 0, error: '', packaging: null}];
    protected activeShipmentPackagings: any[];
    protected overridePackaging: any;
    protected selectedPackaging: any;
    private presetPackaging: number;

    selectPackaging(service: any) {
        this.overridePackaging = service;
        this.handleValidation();
        this.handleAdHocValidation();
    }


    public handleValidation(useWeight?: number, returnStatus?:boolean) {

        if (!this.activeShipment) {
            this.hasValidationErrors = true;
            return;
        }

        let sumWeight = 0;
        let sumVolume = 0;

        if (!sumWeight && this.activeShipment && this.activeShipment.shipment_product_lines.length > 0) {
            sumWeight = this.activeShipment.shipment_product_lines.reduce((accumulator, obj) => {
                return accumulator + (obj.weight * obj.amount_scanned);
            }, 0);
        }

        this.kolliData.price = 0;
        this.kolliData.sumWeight = useWeight ? useWeight : sumWeight;

        this.activeShipmentPackagings = this.shipmentsService.shipmentPackagingsForCarrier(this.activeShipment.carrier_code);
        if (this.activeShipmentPackagings.length === 1) {
            this.selectedPackaging = this.activeShipmentPackagings[0];

        } else if (this.presetPackaging) {
            this.selectedPackaging = this.activeShipmentPackagings.find((item) => {
                return item.id === this.presetPackaging;
            });
        } else if (this.overridePackaging) {
            this.selectedPackaging = this.overridePackaging;
        } else {

            this.selectedPackaging = this.shipmentsService.getShipmentPackageFor(
                this.activeShipment.carrier_code,
                this.activeShipment.is_flex,
                this.activeShipment.is_business,
                this.activeShipment.is_droppoint,
                this.kolliData.sumWeight,
                this.activeShipment.shipment_address.country_code_receiver
            );
        }

        this.activeShipmentPackagings.forEach((item) => {
            item.selected = false
        });

        if (this.selectedPackaging) {

            // update the UI
            for (const packing of this.activeShipmentPackagings) {
                if (this.selectedPackaging && this.selectedPackaging.id === packing.id) {
                    packing.selected = true;
                    break;
                }
            }

            if (
                this.validateAgainstPackaging(this.selectedPackaging, this.kolliData.sumWeight)
            ) {

                this.activeShipment.shipment_services = this.activeShipment.shipment_services.filter((item) => {
                    return item.service_code !== 'packaging'
                })

                const dummyService = new ShipmentService();
                dummyService.service_code = 'packaging';
                dummyService.service_name = this.selectedPackaging.packageType;

                this.activeShipment.shipment_services.push(dummyService);

                this.validationErrorMessage = '';
                if (returnStatus) {
                    return this.validationErrorMessage;
                }
                this.hasValidationErrors = false;

            } else {
                this.validationErrorMessage = 'Udenfor vægt grænser';
                if (returnStatus) {
                    return this.validationErrorMessage;
                }
                this.hasValidationErrors = true;

            }
        } else {
            this.validationErrorMessage = 'Ingen gyldig emballage fundet';
            if (returnStatus) {
                return this.validationErrorMessage;
            }
            this.hasValidationErrors = true;
        }
    }

    validateAgainstPackaging(packaging, sumWeight) {

        if (!packaging) {
            return false;
        }

        if ((packaging.minWeight <= sumWeight &&
                packaging.maxWeight >= sumWeight)
            || (!packaging.minWeight && packaging.maxWeight >= sumWeight)) {
            return true
        } else {
            return false;
        }
    }

    ////


    protected handleAdHocValidation() {

        this.hasValidationErrors = false;
        for (const onecustomProduct of this.customProducts) {
            onecustomProduct.price = 0;
            const valid = this.validateAgainstPackaging(onecustomProduct.packaging, onecustomProduct.weight);
            if (!valid) {
                this.hasValidationErrors = true;
                onecustomProduct.error = 'Ugyldig emballage';
            } else {
                onecustomProduct.error = '';
            }
        }
    }

    protected changeCustomProduct($value: any, customProduct: any) {
        if ($value > 0) {
            customProduct.amount_scanned = 1;
        } else {
            customProduct.amount_scanned = 0;
        }
        customProduct.weight = $value;
        customProduct.packaging = this.shipmentsService.getShipmentPackageFor(
            this.activeShipment.carrier_code,
            this.activeShipment.is_flex,
            this.activeShipment.is_business,
            this.activeShipment.is_droppoint,
            customProduct.weight,
            this.activeShipment.shipment_address.country_code_receiver
        );

        this.handleAdHocValidation();
    }

    get selectablePackagings() {
        return this.activeShipmentPackagings?.filter(service => service.selectable) ?? [];
    }
}
